var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"id":"Fill_1-3","data-name":"Fill 1-3","className":"cls-1","d":"m12,24.07C5.37,24.07,0,18.7,0,12.07c0-3.18,1.26-6.23,3.51-8.48,4.65-4.72,12.25-4.79,16.97-.14,4.72,4.65,4.79,12.25.14,16.97-.05.05-.09.09-.14.14-2.25,2.26-5.3,3.52-8.49,3.51Zm0-17c-1.8,0-3.45.04-4.44.11-2.22.15-2.54,1.18-2.56,4.89.02,3.71.34,4.74,2.56,4.89.99.07,2.64.11,4.44.11s3.45-.04,4.44-.11c1.16-.08,1.78-.41,2.12-1.14.38-1.21.53-2.48.43-3.75.1-1.26-.05-2.54-.43-3.74-.34-.73-.96-1.07-2.13-1.15-.99-.07-2.65-.11-4.44-.11Zm-2,7.34v-4.68l4.92,2.34-4.92,2.34Z"})));
}

Youtube.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 24.07 24.07"};

module.exports = Youtube;

Youtube.default = Youtube;
